import { IconButton } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useCustomTheme } from '../../../context/Theme/ThemeContext';

const ThemeToggle = () => {
    const { isDarkMode, toggleTheme } = useCustomTheme();

    return (
        <IconButton
            onClick={toggleTheme}
            sx={{
                color: 'text.secondary',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    color: 'text.primary',
                    transform: 'scale(1.1)',
                }
            }}
        >
            {isDarkMode ? <LightMode /> : <DarkMode />}
        </IconButton>
    );
};

export default ThemeToggle; 